import React from "react";
import { View, StyleSheet } from "react-native";
import { useTheme } from "@/hooks/useTheme";

export interface PreviewContainerProps {
  children: React.ReactNode;
  style?: any;
}

export function PreviewContainer({ children, style }: PreviewContainerProps) {
  const { colors } = useTheme();

  return <View style={[styles.container, { backgroundColor: colors.background }, style]}>{children}</View>;
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
